export const API_PATH_ApiDeviceMgmtDeviceGet = '/services/devices-mgtm/apiDeviceMgmtDeviceGet';
